import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 动态引入modules模块
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  state: {
    hasLogin: false,
    appKey: null,
    appType: null,
    tenantId: null
  },
  mutations: {
    setLogin: (state, value) => {
      state.hasLogin = value
    },
    setAppKey: (state, appKey) => {
      state.appKey = appKey
    },
    setAppType: (state, appType) => {
      state.appType = appType
    }
   
  },
  actions: {
    defaultState ({ state, commit }) {
      commit('setLogin', !!state.auth.token)
      // commit('setLogin', state.auth.token ? true : false)
    },
    userLogin ({ commit }, data) {
      commit('setLogin', true)
      commit('auth/setData', data)
    },
    userLogout ({ commit }) {
      commit('setAppKey', '')
      commit('setLogin', false)
      commit('auth/clearData')
    }

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js